import { render, staticRenderFns } from "./fixed-select-bar.vue?vue&type=template&id=22ce8613&scoped=true&"
import script from "./fixed-select-bar.vue?vue&type=script&lang=js&"
export * from "./fixed-select-bar.vue?vue&type=script&lang=js&"
import style0 from "./fixed-select-bar.vue?vue&type=style&index=0&id=22ce8613&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce8613",
  null
  
)

export default component.exports